import { FC, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { CourseEvent } from '../../models/CourseEvent';
import Form from 'react-bootstrap/Form';
import WaitlistEndpoint from '../../../api/endpoint/WaitlistEndpoint';

interface WaitlistProps {
    course: CourseEvent;
    show: boolean;
    onHide: () => void;
    initiateReload: () => void;
}

export const WaitlistModal: FC<WaitlistProps> = (props) => {
    const [validated, setValidated] = useState(false);
    const [fullName, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');

    const handleSubmit = (event: any) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else if(form.checkValidity() === true) {
            event.preventDefault();
            handleRegister();
            props.initiateReload();
            props.onHide();
        }

        setValidated(true);
    };

    const handleRegister = async() => {
        const waitlist = {
            course_event_id: props.course.course_event_id,
            full_name: fullName,
            email: email,
            phone_number: phone
        };

        const waitlistResult = await WaitlistEndpoint.Create(waitlist);

        if(!waitlistResult || waitlistResult.errors.length > 0 || !waitlistResult.data){
            console.error('Error joining waitlist');
        }
    }

    return (
        <Modal
            show={props.show}
            size="lg"
            aria-labelledby="waitlist-title"
            centered
            onHide={props.onHide}
        >
            <Modal.Header closeButton>
                <Modal.Title id="waitlist-title">
                    Join Waitlist for {props.course.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="waitlist-name">
                        <Form.Label>Full Name</Form.Label>
                        <Form.Control type="text" required value={fullName} onChange={(e:any) => setFullName(e.target.value)}/>
                        <Form.Control.Feedback type="invalid">Please enter your full name.</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="waitlist-email">
                        <Form.Label>Email address</Form.Label>
                        <Form.Control type="email" required value={email} onChange={(e: any) => setEmail(e.target.value)}/>
                        <Form.Control.Feedback type="invalid">Please enter your email.</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="waitlist-phone">
                        <Form.Label>Phone Number</Form.Label>
                        <Form.Control type="tel" required value={phone} onChange={(e:any) => setPhone(e.target.value)}/>
                        <Form.Control.Feedback type="invalid">Please enter your phone number.</Form.Control.Feedback>
                    </Form.Group>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={props.onHide}>Close</Button>
                        <Button variant="primary" className="text-light" type="submit">Submit</Button>
                    </Modal.Footer>
                </Form>
            </Modal.Body>
            
        </Modal>
    )
}